import React from 'react';
import 'slick-carousel/slick/slick.css';
import style from './block.module.scss';
import { ReactComponent as Facebook } from '../assets/ic_facebook.svg';
import { ReactComponent as Instagram } from '../assets/ic_instagram.svg';
import { ReactComponent as TripAdvisor } from '../assets/ic_trip.svg';
import { ReactComponent as Youtube } from '../assets/ic_youtube.svg';
import { BlockWrapper, defineBlock, smartProps } from '@smartfire/js-block-engine';
import { EditableText } from '@smartfire/components';

function Block({ socials, menu, cgv }) {
    return (
        <BlockWrapper.Footer className={style.block}>
            <div className={style.content}>
                <div className={style.grid}>
                    <div className={style.col1}>
                        <EditableText smartProp="titleColumn1" className={style.title} />
                        <EditableText
                            smartProp="contactInfos"
                            allowedFormats={['core/bold', 'core/italic', 'core/link']}
                            className={style.contact}
                        />
                    </div>
                    <div className={style.col2}>
                        <EditableText smartProp="titleColumn2" className={style.title} />
                        <div className={style.menuFooter}>
                            {menu &&
                                menu.map((item, index) => (
                                    <a className={style.link} key={`menu-footer-link-${index}`} href={item.url}>
                                        {item.title}
                                    </a>
                                ))}
                        </div>
                    </div>
                    <div className={style.col3}>
                        <EditableText smartProp="titleColumn3" className={style.title} />
                        <div className={style.socialBlock}>
                            {socials?.instagram && (
                                <a target="_blank" rel="noreferrer noopener" href={socials.instagram}>
                                    <Instagram />
                                </a>
                            )}
                            {socials?.facebook && (
                                <a target="_blank" rel="noreferrer noopener" href={socials.facebook}>
                                    <Facebook />
                                </a>
                            )}
                            {socials?.youtube && (
                                <a target="_blank" rel="noreferrer noopener" href={socials.youtube}>
                                    <Youtube />
                                </a>
                            )}
                            {socials?.trip && (
                                <a target="_blank" rel="noreferrer noopener" href={socials.trip}>
                                    <TripAdvisor />
                                </a>
                            )}
                        </div>
                    </div>
                </div>
                <div className={style.menuCgv}>
                    {cgv &&
                        cgv.map((item, index) => (
                            <div key={item.guid}>
                                <a className={style.link} key={`menu-cgv-item-${index}`} href={item.url}>
                                    {item.title}
                                </a>
                            </div>
                        ))}
                </div>
            </div>
        </BlockWrapper.Footer>
    );
}

export default defineBlock({
    Block: Block as React.FC<unknown>,
    smartProps: {
        titleColumn1: smartProps.string.withDefault('Guédelon'),
        contactInfos: smartProps.string.withDefault('Adresse'),
        titleColumn2: smartProps.string.withDefault('pour aller plus loin'),
        menuFooter: smartProps.array.withDefault([]),
        titleColumn3: smartProps.string.withDefault('restons connectés'),
        menuCGV: smartProps.array.withDefault([]),
    },
    setup: {
        title: 'Footer',
    },
});
